/**
 * Especifica una root variable de css
 * @param variable
 * @param value
 */
export const setRootVariable = (variable: string, value: string) => {
  const root = document.querySelector(':root') as HTMLElement | null;
  if (root !== null) {
    root.style.setProperty(variable, value);
  }
};
